
import React, { createContext, useContext, ReactNode } from "react";
import { useAuthentication } from "@/hooks/useAuthentication";

export type SignUpFormValues = {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  password: string;
  confirmPassword: string;
  acceptTerms: boolean;
};

export type LoginFormValues = {
  email: string;
  password: string;
  rememberMe?: boolean;
};

type AuthContextType = {
  isSubmitting: boolean;
  passwordStrength: number;
  otpVerificationRequired: boolean;
  emailForVerification: string;
  handleCalculatePasswordStrength: (password: string) => void;
  handleSignUp: (data: SignUpFormValues) => Promise<void>;
  handleLogin: (data: LoginFormValues) => Promise<void>;
  handleOTPVerification: (otp: string) => Promise<void>;
  handleResendOTP: () => Promise<void>;
  handleCancelOTP: () => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const auth = useAuthentication();
  
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
